import * as React from 'react';
import styled from 'styled-components';
import { Colors, Spinner } from '@origin-digital/style-guide';

export interface ILoadingContextProps {
  visible?: boolean;
  setVisibility?: (visibile: boolean) => void;
}

export type ILoadingContext<T> = T & ILoadingContextProps;

export const LoadingContext = React.createContext<ILoadingContextProps>({
  visible: false
});

interface IProps {
  visible?: boolean;
}

const LoadingBase = styled.div`
  align-items: center;
  background: ${Colors.WHITE};
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  opacity: ${({ visible }: IProps) => (visible ? 1 : 0)};
  top: 0;
  right: 0;
  pointer-events: ${({ visible }: IProps) => (visible ? 'all' : 'none')};
  position: fixed;
  z-index: 10;
  transition: opacity ${({ visible }: IProps) => (visible ? '250ms' : '300ms')} ease-in-out;

  svg {
    transform: scale(${({ visible }: IProps) => (visible ? 1 : 0)});
    transition: scale 800ms ease-in-out;
  }
`;

const SPINNER_SIZE = 96;

const Loading: React.SFC = () => (
  <LoadingContext.Consumer>
    {({ visible }) => (
      <LoadingBase data-id="spinner" visible={visible}>
        <Spinner size={SPINNER_SIZE} />
      </LoadingBase>
    )}
  </LoadingContext.Consumer>
);

export default Loading;

export function withLoadingContext<T>(Component: any): React.SFC<ILoadingContext<T>> {
  class ConnectedComponent extends React.PureComponent<ILoadingContextProps> {
    public render() {
      return <Component {...this.props} />;
    }
  }

  // eslint-disable-next-line react/display-name
  return (props: T) => (
    <LoadingContext.Consumer>
      {({ setVisibility }) => <ConnectedComponent {...props} setVisibility={setVisibility} />}
    </LoadingContext.Consumer>
  );
}
